// Branded "set a new password" — reached from the emailed link /reset-password/<token>. Posts the
// token + new password to the API, which validates the token and sets the Keycloak credential.
import { html, signal, navigate } from '../shared/t4.js';
import { api } from '../shared/api.js';
import { theme, toggleTheme } from '../shared/theme.js';
import { icon } from '../shared/icons.js';

export function resetScreen(token){
  const pw      = signal('');
  const confirm = signal('');
  const done    = signal(false);
  const loading = signal(false);
  const error   = signal('');

  async function submit(e){
    e.preventDefault();
    if(pw.value.length < 8){ error.value = 'Password must be at least 8 characters.'; return; }
    if(pw.value !== confirm.value){ error.value = 'The passwords don\'t match.'; return; }
    loading.value = true; error.value = '';
    try {
      await api.post('/auth/reset-password', { token, password: pw.value });
      done.value = true;
    } catch(err){
      error.value = (err.data && err.data.error) || err.message || 'Could not reset the password';
    }
    loading.value = false;
  }

  const form = () => html`
    <form class="login-card card" @submit=${submit}>
      <div class="card-body">
        <div class="brand-lockup">
          <span class="brand-dot"></span><span class="brand-name">aboo</span><span class="brand-sub">admin</span>
        </div>
        <h1 class="login-title">Set a new password</h1>
        <p class="login-hint mb-4">Choose a new password for your account.</p>

        <label class="form-label">New password</label>
        <input class="form-control mb-3" type="password" autocomplete="new-password" placeholder="At least 8 characters"
               .value=${pw} @input=${e => { pw.value = e.target.value; }}>

        <label class="form-label">Confirm password</label>
        <input class="form-control mb-3" type="password" autocomplete="new-password" placeholder="Re-enter it"
               .value=${confirm} @input=${e => { confirm.value = e.target.value; }}>

        ${() => error.value ? html`<div class="alert alert-danger py-2 mb-3">${error}</div>` : null}

        <button class="btn btn-primary btn-block" type="submit"
                ?disabled=${() => loading.value || !pw.value || !confirm.value}>
          ${() => loading.value ? 'Saving…' : 'Reset password'}
        </button>
        <p class="login-alt mt-3"><a @click=${() => navigate('/login')}>← Back to sign in</a></p>
      </div>
    </form>`;

  const success = () => html`
    <div class="login-card card">
      <div class="card-body signup-done">
        <div class="brand-lockup"><span class="brand-dot"></span><span class="brand-name">aboo</span></div>
        <div class="signup-tick">✓</div>
        <h1 class="login-title">Password reset</h1>
        <p class="login-hint mb-4">Your password has been changed. Sign in with your email and new password.</p>
        <button class="btn btn-primary btn-block" @click=${() => navigate('/login')}>Continue to sign in</button>
      </div>
    </div>`;

  return html`
    <div class="login-wrap">
      <button type="button" class="theme-toggle login-toggle" title="Toggle light / dark"
              @click=${() => toggleTheme()}>${() => theme.value === 'dark' ? icon('sun', {size: 18}) : icon('moon', {size: 18})}</button>
      ${() => done.value ? success() : form()}
    </div>`;
}
